export default class Reference {
    static internalReferences = [];
  
    static addToReference(key, object) {
        if(!Reference.internalReferences[key]) {
            Reference.internalReferences[key] = [];          
        }
        Reference.internalReferences[key].push(object);
    }
  
    static getReferences(key) {
        return Reference.internalReferences[key] || [];
    }
}